import React, { useState } from 'react';
import { SiYoutube, SiThreads, SiTiktok, SiTelegram, SiBluesky, SiMastodon, SiPinterest, SiGithub, SiDiscord } from 'react-icons/si';
import { Linkedin } from 'lucide-react';
import { LuInstagram, LuFacebook } from 'react-icons/lu';
import BaseModal from './BaseModal';
import { apiService } from '../api/apiclient';
import TokenSubmitModal from './TokenSubmitModal';

const AVAILABLE_PLATFORMS = [
    { id: 'instagram', name: 'Instagram', icon: <LuInstagram size={24} />, color: 'hover:border-pink-500 hover:text-pink-500 hover:bg-pink-50/30' },
    { id: 'discord', name: 'Discrod', icon: <SiDiscord size={24} />, color: 'hover:border-black hover:text-black hover:bg-gray-50' },
    { id: 'facebook', name: 'Facebook', icon: <LuFacebook size={24} />, color: 'hover:border-blue-600 hover:text-blue-600 hover:bg-blue-50/30' },
    { id: 'github', name: 'Github', icon: <SiGithub size={24} />, color: 'hover:border-red-600 hover:text-red-600 hover:bg-red-50/30' },
    { id: 'tiktok', name: 'Tiktok', icon: <SiTiktok size={24} />, color: 'hover:border-red-600 hover:text-red-600 hover:bg-red-50/30' },
    { id: 'pinterest', name: 'Pinterest', icon: <SiPinterest size={24} />, color: 'hover:border-red-600 hover:text-red-600 hover:bg-red-50/30' },
    { id: 'linkedin', name: 'Linkedin', icon: <Linkedin size={24} />, color: 'hover:border-red-600 hover:text-red-600 hover:bg-red-50/30' },
    //{ id: 'linkedinB', name: 'Linkedin Business', icon: <Linkedin size={24} />, color: 'hover:border-red-600 hover:text-red-600 hover:bg-red-50/30' },
    { id: 'telegram', name: 'Telegram', icon: <SiTelegram size={24} />, color: 'hover:border-red-600 hover:text-red-600 hover:bg-red-50/30' },
    { id: 'mastodon', name: 'Mastodon', icon: <SiMastodon size={24} />, color: 'hover:border-red-600 hover:text-red-600 hover:bg-red-50/30' },
    { id: 'bluesky', name: 'Bluesky', icon: <SiBluesky size={24} />, color: 'hover:border-blue-600 hover:text-blue-600 hover:bg-blue-50/30' },
    { id: 'threads', name: 'Threads(Building)', icon: <SiThreads size={24} />, color: 'hover:border-red-600 hover:text-red-600 hover:bg-red-50/30' },
    { id: 'youtube', name: 'Youtube', icon: <SiYoutube size={24} />, color: 'hover:border-red-600 hover:text-red-600 hover:bg-red-50/30' },

];
const config = ["Bluesky", "telegram"];

const PlatformConnectModal = ({ isOpen, onClose }) => {
    const [loadingId, setLoadingId] = useState(null);
    const [showModal, setShowModal] = useState(null);
    const [platformId, setPlatformId] = useState(null);


    const handleConnect = async (platform) => {
        setPlatformId(platform);
        if (config.includes(platform)) {
            setShowModal(true);
        } else {
            try {
                setLoadingId(platform);
                const response = await apiService.getAuthUrl(platform);
                if (response.url) {
                    window.location.href = response.url;
                } else {
                    alert(response.message);
                    if (onClose) onClose();
                }
            } catch (err) {
                alert('Authorization failed to start');
                setLoadingId(null);
            }
        }
    };

    const handleSubmitToken = async (platform, data) => {
        try {
            const response = await apiService.submitToken(platform, data);
            if (response.success) {
                window.location.href = '/accounts';
            }
        } catch (err) {
            alert('Authorization failed to start');
            setLoadingId(null);
        }
    };

    return (
        <BaseModal isOpen={isOpen} onClose={onClose} title="Bind New Platform">
            <p className="text-gray-500 mb-8 text-sm">
                Select a social platform to authorize securely
            </p>
            <div className="grid grid-cols-3 gap-4">
                {AVAILABLE_PLATFORMS.map((platform) => (
                    <button
                        key={platform.id}
                        disabled={loadingId !== null}
                        onClick={() => handleConnect(platform.id)}
                        className={`flex flex-col items-center gap-4 p-6 border-2 border-gray-100 rounded-2xl transition-all group ${platform.color} active:scale-95 disabled:opacity-50`}
                    >
                        <div className={`p-3 bg-gray-50 rounded-xl transition-colors ${loadingId === platform.id ? '' : 'group-hover:bg-white'}`}>
                            {loadingId === platform.id ? (
                                <div className="w-6 h-6 border-2 border-current border-t-transparent rounded-full animate-spin" />
                            ) : (
                                platform.icon
                            )}
                        </div>
                        <span className="font-bold text-gray-700 group-hover:text-inherit">
                            {platform.name}
                        </span>
                    </button>
                ))}
            </div>

            <div className="mt-8 pt-6 border-t border-gray-100 text-center">
                <p className="text-[10px] text-gray-400 leading-relaxed">
                    After clicking the icon, you will be redirected to the official website. The authorization process follows the OAuth 2.0 standard.
                </p>
            </div>
            <TokenSubmitModal
                platform={platformId}
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                onSubmit={handleSubmitToken}
            />
        </BaseModal>
    );
};

export default PlatformConnectModal;